import { User } from '@/models/user.model'
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useAppStore = create<AppState>()(
    persist(
        (set) => ({
            user: null,
            accessToken: null,
            refreshToken: null,
            expiresIn: null,
            setUser: (user: User | null) => set({ user }),
            setTokens: (tokens) => {
                if (tokens) {
                    set({
                        accessToken: tokens.accessToken,
                        refreshToken: tokens.refreshToken,
                        expiresIn: tokens.expiresIn,
                    })
                } else {
                    set({
                        accessToken: null,
                        refreshToken: null,
                        expiresIn: null,
                    })
                }
            },
        }),
        {
            name: 'kbs-app',
            storage: createJSONStorage(() => localStorage),
        }
    )
)

export interface AppState {
    user: User | null,
    accessToken?: string | null,
    refreshToken?: string | null,
    expiresIn?: number | null,
    setUser: (user: User | null) => void,
    setTokens: (tokens: { accessToken: string; refreshToken: string; expiresIn: number } | null) => void,
}